import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default (
  <Route key="/consumer/features/body-editor" element={<DefaultConsumerLayout />}>
    <Route path="consumer/features/body-editor" element={<AsyncPage />} />
  </Route>
);
